// extracted by mini-css-extract-plugin
export default {"mapasPage":"mapaPage_mapasPage__Q3vUr"};